/**
 * Andon da Liderança — níveis de escalonamento e tempos de tolerância.
 */

import type { LstCargo } from '../types';

export interface AndonEscalationLevel {
  level: 1 | 2 | 3;
  role: LstCargo;
  label: string;
  shortLabel: string;
  toleranceMinutes: number;
  escalationRule: string;
}

export const ANDON_ESCALATION_LEVELS: AndonEscalationLevel[] = [
  {
    level: 1,
    role: 'supervisor',
    label: 'Nível 1 — Supervisor',
    shortLabel: 'Supervisor',
    toleranceMinutes: 30,
    escalationRule: 'Se desvio não tratado em 30 min → Alerta ao Nível 2',
  },
  {
    level: 2,
    role: 'coordenador',
    label: 'Nível 2 — Coordenador',
    shortLabel: 'Coordenador',
    toleranceMinutes: 60,
    escalationRule: 'Se não resolvido em 60 min → Alerta ao Nível 3',
  },
  {
    level: 3,
    role: 'gerente',
    label: 'Nível 3 — Gerente / Diretor',
    shortLabel: 'Gerente/Diretor',
    toleranceMinutes: 120,
    escalationRule: 'Escalonamento executivo · SLA crítico 120 min',
  },
];

/** Nível Andon ativo conforme o cargo do gestor logado. */
export function resolveAndonLevelForCargo(cargo: LstCargo): 1 | 2 | 3 {
  if (cargo === 'diretor' || cargo === 'gerente') return 3;
  if (cargo === 'coordenador') return 2;
  return 1;
}
